<form class="userloginform" [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="desktopForm && !isDemoLogin && !signUpPage">
  <div class="row align-items-center">
      <div class="col-auto d-flex">
          <i class="mdi mdi-account text-light" style="margin-right: 4px; font-size: 17px;"></i>
          <input type="text" formControlName="username" class="form-control" placeholder="Username">
          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required">The User Name field is required</div>
          </div>
      </div>
      <div class="col-auto px-0">
          <div class="input-group">
              <input type="password" formControlName="password" class="form-control" placeholder="Password">
              <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">The Password field is required</div>
              </div>
          </div>
      </div>
      <div class="col-auto">
          <button type="submit" class="btn btnlogin" [disabled]="isLoad">
            Login
            <i *ngIf="!isLoad" class="mdi mdi-logout-variant"></i>
            <i *ngIf="isLoad" class="mdi mdi-spin mdi-loading"></i>
          </button>
          <button *ngIf="env.host.signUpActive" style="margin-left: 5px;" type="button" class="btn btnlogin" routerLink="/signup">
            Sign up
          </button>
          <button *ngIf="!env.host.signUpActive && env.host.demoLogin" style="margin-left: 5px;" type="button" class="btn btnlogin" [disabled]="isLoadDemo" (click)="loginWIthDemoId()">
            Demo
            <i *ngIf="!isLoadDemo" class="mdi mdi-logout-variant"></i>
            <i *ngIf="isLoadDemo" class="mdi mdi-spin mdi-loading"></i>
          </button>

          <span class="d-none d-sm-inline-block" *ngIf="env.host.signUpActive">
            <a href="javascript:void(0)" class="reset-pass" (click)="openResetPassModal(resetpass)">forgot password?</a>
          </span>
      </div>
      
  </div>
</form>

<div class="login-page1" *ngIf="!desktopForm && !isDemoLogin && !signUpPage">
  <div class="modal-dialog login-modal modal-ui modal-dialog-centered">
    <div class="modal-content">
        <!-- <div class="modal-header">
        </div> -->
        <!-- <img class="img-fluid logoLoginPage d-block d-sm-none" src="assets/img/{{env.host.name}}/m-logo.png" alt="">
        <img class="img-fluid logoLoginPage d-none d-sm-block" src="assets/img/{{env.host.name}}/logo.png" alt=""> -->
        <img class="img-fluid logoLoginPage" src="assets/img/{{env.host.name}}/m-logo.png" alt="">
        <div class="modal-body">
          <div class="container-fluid">

            <div class="row align-items-center justify-content-center">
              <!-- <div class="col-md-5 loginleft">
                <div class="text-center my-2">
                    <img class="img-fluid logoLoginPage" src="assets/img/{{env.host.name}}/logo.png" alt="">
                    <img class="img-fluid filterlogin" src="assets/img/loginImg2.png">
                </div>
              </div> -->
              <div class="col-md-8 loginright">
                  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                      <input class="form-control" name="User Name" formControlName="username" type="text"  required="" placeholder="Enter Username">
                      <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">The User Name field is required</div>
                      </div>
                    </div>

                    <div class="form-group">
                      <input id="passwordIpt" class="form-control" name="Password" formControlName="password" type="password" required="" placeholder="Enter Password">
                      <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">The Password field is required</div>
                      </div>
                      <a class="eye-passcode" (click)="togglePasscode()">
                        <i *ngIf="passType" class="mdi mdi-eye"></i>
                        <i *ngIf="!passType" class="mdi mdi-eye-off"></i>
                      </a>
                    </div>

                    <div class="form-group">
<!--                      <div class="custom-control custom-checkbox">-->
<!--                        <input type="checkbox" class="custom-control-input" id="customCheck2">-->
<!--                        <label class="custom-control-label" for="customCheck2">Remember me</label>-->
<!--                      </div>-->

                      <small>This site is protected by reCAPTCHA and the Google <a href="#">Privacy Policy</a> and <a
                          href="#">Terms of Service apply</a>.</small>
                    </div>

                    <div class="form-group text-right">
                      <button type="submit" class="btn btn-login" [disabled]="isLoad">
                        Log In
                        <i *ngIf="!isLoad" class="mdi mdi-logout-variant"></i>
                        <i *ngIf="isLoad" class="mdi mdi-spin mdi-loading"></i>
                      </button>
                    </div>

                    <div class="form-group text-right" *ngIf="env.host.demoLogin">
                      <button type="button" class="btn btn-login" [disabled]="isLoadDemo" (click)="loginWIthDemoId()">
                        Demo
                        <i *ngIf="!isLoadDemo" class="mdi mdi-logout-variant"></i>
                        <i *ngIf="isLoadDemo" class="mdi mdi-spin mdi-loading"></i>
                      </button>
                    </div>

                  </form>
              </div>
            </div>

          </div>
        </div>
    </div>
  </div>
</div>


<button style="margin-top: 10px;margin-right: 5px;" *ngIf="!_common.getToken() && isDemoLogin && !env.host.signUpActive && !signUpPage" type="button" class="btn btn-login py-1" (click)="loginWIthDemoId()">Demo
  <i *ngIf="isLoadDemo" class="mdi mdi-spin mdi-loading"></i>
</button>

<div *ngIf="!desktopForm && !signUpPage && !router.url.includes('login')" class="d-flex align-items-center">
  <button style="margin-top: 10px;margin-right: 5px;" *ngIf="!_common.getToken() && env.host.signUpActive" type="button" class="btn btn-login py-1" routerLink="/signup">signup
  </button>
  <div class="d-inline-block d-sm-none" *ngIf="env.host.signUpActive">
    <a href="javascript:void(0)" class="reset-pass" (click)="openResetPassModal(resetpass)">forgot?</a>
  </div>
</div>

<iframe *ngIf="signUpPage" class="embed-responsive-item signup-iframe" scrolling="yes" style="min-height: 500px;" [src]="env.host.iframeDomainUrl + 'signup/' + env.domain + env.trafficTag | safeURL" allowfullscreen="true" title="game"></iframe>


<div class="modal fade" bsModal #changePwd="bs-modal" [config]="{backdrop: true}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
    <div class="modal-dialog land-login-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pull-left" id="change-password">Change Password</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="changePwd.hide()">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>
            <div class="modal-body">
              <app-change-password class="modal-change-pwd" (openLogin)="loginRoute()" [isModal]="true">
              </app-change-password>
            </div>
        </div>
    </div>
</div>

<ng-template #signup>
  <div class="modal-body signup p-0">
    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true">×</span>
    </button>
    <iframe class="embed-responsive-item signup-iframe" scrolling="yes" style="min-height: 500px;" [src]="env.host.iframeDomainUrl + 'signup/' + env.domain + env.trafficTag | safeURL" allowfullscreen="true" title="game"></iframe>
  </div>
</ng-template>

<ng-template #resetpass>
  <div class="modal-body resetpass p-0">
    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true">×</span>
    </button>
    <iframe class="embed-responsive-item resetpass-iframe" scrolling="yes" style="min-height: 500px;" [src]="env.host.iframeDomainUrl + 'forgot-password/' +env.domain | safeURL" allowfullscreen="true" title="game"></iframe>
  </div>
</ng-template>
